import { render, staticRenderFns } from "./webPage.vue?vue&type=template&id=b32b1502&scoped=true&"
import script from "./webPage.vue?vue&type=script&lang=js&"
export * from "./webPage.vue?vue&type=script&lang=js&"
import style0 from "./webPage.vue?vue&type=style&index=0&id=b32b1502&lang=scss&scoped=true&"
import style1 from "./webPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32b1502",
  null
  
)

export default component.exports